import { useRequest } from 'ahooks';
import { getPopularLatestPolicy } from '@axios/api'
import { SPECIFIC_ORG_LIST, SPECIFIC_KEYWORD_LIST } from '@constants'
import util from '../../../utils/utils';

function useGetLatestPolicy(){
  const cacheKey = `latestPolicy:${util.getCurrentClientId()}`;
  const { loading, data } = useRequest(
    async () => {
      try {
        const resp = await getPopularLatestPolicy({
          num:5,
          select_by:'time',
          // preference_orgs:SPECIFIC_ORG_LIST,
          // preference_keywords:SPECIFIC_KEYWORD_LIST
        });
        return resp?.data?.result ?? []
      } catch (error) {
        return [];
      }
    },
    {          
      debounceWait: 500,     // 下调到500ms，加快首页并发加载
      refreshDeps:[],
      retryCount: 1,
      // ✅ 缓存配置：10分钟内复用
      cacheKey,
      staleTime: 10 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    },
  );

    return {
      latestPolicyLoading:loading,
      latestPolicyData:data,
    }
}

export default useGetLatestPolicy